import React, { useState, useEffect } from "react";
import { DateTimePicker, DatePicker, TimePicker } from "@material-ui/pickers";
import { injectIntl } from "react-intl";
import defaultDatepickerProptypes from "./default-proptypes";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "components/icon-button";
import Icon from "components/icon";
import {
  dateFormat as defaultDateFormat,
  dateFormatWithTime as defaultDateFormatWithTime,
  timeFormat,
} from "components/common";
import styles from "./styles/date-picker.css.js";
import withStyles from "components/with-styles";

const DateTimePickerAdornment = () => (
  <InputAdornment position="end">
    <IconButton>
      <Icon name="date-range" />
    </IconButton>
  </InputAdornment>
);

const CustomDatepicker = ({
  intl,
  dateFormat,
  onChange,
  value,
  isStart,
  isEnd,
  withTime = true,
  onlyTime = false,
  classes,
  ...props
}) => {
  const [internalValue, setInternalValue] = useState(value);

  const handleChange = value => setInternalValue(value);

  const handleAccept = value => {
    let date = null;

    if (isStart && !withTime) {
      date = value ? value.startOf("day").toDate() : null;
    } else if (isEnd && !withTime) {
      date = value ? value.endOf("day").toDate() : null;
    } else {
      date = value ? value.toDate() : null;
    }

    onChange(date);
  };

  useEffect(
    () => {
      if (value !== internalValue) {
        setInternalValue(value);
      }
    },
    [internalValue, value],
  );

  const commonProps = {
    cancelLabel: intl.formatMessage({ id: "datepicker.cancel" }),
    clearLabel: intl.formatMessage({ id: "datepicker.clear" }),
    okLabel: intl.formatMessage({ id: "datepicker.ok" }),
    todayLabel: intl.formatMessage({ id: "datepicker.today" }),
    invalidDateMessage: intl.formatMessage({ id: "datepicker.date.notvalid" }),
    margin: "normal",
    clearable: true,
    onChange: handleChange,
    onAccept: handleAccept,
    value: internalValue,
    allowKeyboardControl: false,
    InputProps: {
      endAdornment: <DateTimePickerAdornment />,
      className: classes.date_picker,
    },
    ...props,
  };

  if (onlyTime) {
    return <TimePicker {...commonProps} ampm={false} openTo="hours" views={["hours", "minutes"]} format={timeFormat} />;
  }

  if (withTime) {
    return (
      <DateTimePicker {...commonProps} format={dateFormat ? dateFormat : defaultDateFormatWithTime} ampm={false} />
    );
  }

  return <DatePicker {...commonProps} format={dateFormat ? dateFormat : defaultDateFormat} showTodayButton />;
};

CustomDatepicker.propTypes = {
  ...defaultDatepickerProptypes,
};

export default injectIntl(withStyles(styles)(CustomDatepicker));
